import React from "react";
import { FaBuilding, FaGraduationCap } from "react-icons/fa";

const InstitutionDetailsCard = ({ formData }) => {


  return (
    <div className="viewing-organiser-card">
      <div className="viewing-organiser-card__header viewing-organiser-card__header--secondary">
        <FaBuilding className="viewing-organiser-card__icon" />
        <h2 className="viewing-organiser-card__title">Business & Banking Details</h2>
      </div>
      <div className="viewing-organiser-card__body">
        <table className="viewing-organiser-table">
          <tbody>
            <tr className="viewing-organiser-table__label-row">
              <td className="viewing-organiser-table__label-cell">Company</td>
              <td className="viewing-organiser-table__value-cell">
                {formData.company || "Not provided"}
              </td>
            </tr>
            <tr className="viewing-organiser-table__label-row">
              <td className="viewing-organiser-table__label-cell">Account Number</td>
              <td className="viewing-organiser-table__value-cell">
                {formData.bank_account_number || "Not provided"}
              </td>
            </tr>
            <tr>
              <td className="viewing-organiser-table__label-cell">VAT Number</td>
              <td className="viewing-organiser-table__value-cell">
                {formData.vat_no || "Not provided"}
              </td>
            </tr>
            <tr>
              <td className="viewing-organiser-table__label-cell">Bank Name</td>
              <td className="viewing-organiser-table__value-cell">
                {formData.bank_name || "Not provided"}
              </td>
            </tr>
            <tr>
              <td className="viewing-organiser-table__label-cell">Paystack Subaccount</td>
              <td className="viewing-organiser-table__value-cell">
                {formData.paystack_subaccount_code || "Not created"}
              </td>
            </tr>
            <tr>
              <td className="viewing-organiser-table__label-cell">Payout Enabled</td>
              <td className="viewing-organiser-table__value-cell">
                <span className={`status-badge ${formData.payout_enabled ? 'status-active' : 'status-inactive'}`}>
                  {formData.payout_enabled ? 'Enabled' : 'Disabled'}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default InstitutionDetailsCard;
